import { ComponentStyleProps } from "../../../../../lib/styles/props/component-style-props";
import { useMemo } from "react";
import log from "loglevel";
import {
  CMButtonSearchConditionMaster,
  SearchDropdownDisplayValue,
} from "@pscsrvlab/psc-react-components";
import useCustomToast from "../../../../../hooks/use-custom-toast";
import { stockRequestApi } from "../../../../../store/api/enhanced-api";
import { errorMessageOf } from "../../../../../lib/util/error-util";
import { hasValue } from "../../../../../lib/util/common-util";
import { useAppTranslation } from "../../../../../hooks/use-app-translation";

export type ButtonSearchConditionProjectProps = {
  label: string;
  placeholder?: string;

  /**
   * 値。案件ID。
   */
  value?: number | null;

  hideClearButton?: boolean;
  searchResultNone: string;

  onChange?: (value: number | null) => void;
} & ComponentStyleProps;
export const ButtonSearchConditionProject = ({
  label,
  placeholder = "",

  value,

  hideClearButton = false,
  searchResultNone,

  onChange,

  sx,
  ...rest
}: ButtonSearchConditionProjectProps) => {
  const { t } = useAppTranslation();
  const { errorToast } = useCustomToast();

  const labelSubmit = useMemo(() => t("btn.確定ボタン"), [t]);
  const labelClear = useMemo(() => t("btn.クリアボタン"), [t]);

  const [triggerListProjectQuery] = stockRequestApi.useLazyListProjectQuery();

  const [triggerGetProjectQuery] = stockRequestApi.useLazyGetProjectQuery();

  const toDisplayValue: (
    value: number,
  ) => Promise<SearchDropdownDisplayValue> = async (value) => {
    try {
      const project = await triggerGetProjectQuery({
        projectId: value,
      }).unwrap();
      return {
        headingLabel: undefined,
        mainLabel: project.projectControlNumber ?? "",
      };
    } catch (e) {
      log.error(errorMessageOf(e));
      return { headingLabel: undefined, mainLabel: "" };
    }
  };

  const handleSearch: (text: string) => Promise<number[]> = async (
    text: string,
  ) => {
    try {
      const selectableProjects: number[] = (
        await triggerListProjectQuery({
          projectControlNumber: text,
        }).unwrap()
      )
        .map((v) => v?.id)
        .filter(hasValue);
      return selectableProjects;
    } catch (e) {
      log.error(errorMessageOf(e));
      errorToast(t("mes.汎用エラーメッセージ"));
      return [];
    }
  };

  const capitalizedLabel = label;

  return (
    <CMButtonSearchConditionMaster<number>
      label={capitalizedLabel}
      placeholder={placeholder}
      menuShowMaxCount={30}
      value={value}
      hideClearButton={hideClearButton}
      labelSubmit={labelSubmit}
      labelClear={labelClear}
      searchResultNone={searchResultNone}
      toDisplayValue={toDisplayValue}
      onSearch={handleSearch}
      onChange={onChange}
      sx={sx}
      {...rest}
    />
  );
};
